import { JSX } from "react";

interface BulkTerminationProjectResponseModel {
  hasTerminations: boolean;
  isReadOnly: boolean;
  projectId: number;
  projectName: string;
  templateName: string;
  hasSuccessfulLatestRun: boolean;
  vaClaimsColumnEnabled: boolean;
  tricareClaimsColumnEnabled: boolean;
}

interface BulkCreateProviderTerminationsModel {
  //returned from the previous API call
  bulkProviderTerminationId: number;

  bulkProviderTerminationMethod: BulkProviderTerminationMethod;

  customProjectIds: number[];

  emailOnSuccess: boolean;

  exportName: string;

  formatType: string;

  includedReports?: IncludedReports;

  isDistinctServicingProviderReport: boolean;

  lineOfBusiness: string;

  // from the comment field
  reasonDescription: string;

  reasonName: string;

  terminateByNpi: boolean;

  terminateByTin: boolean;

  terminateByAllLocations: boolean;

  terminateByAllSpecialties: boolean;
}

enum TerminationsWizardContextSteps {
  "SelectProjects",
  "ImportList",
  "Review",
  "ConfigureReport",
}

interface TerminationsWizardStepProps {
  formIsValid: (flag: boolean) => void;
}

enum BulkProviderTerminationMethod {
  Unknown = "Unknown",
  Import = "Import",
  Ghost = "Ghost",
}

interface ImportBulkTerminationFileResponse {
  bulkProviderTerminationId: number;
  validRecordsCount: number;
  recordsInvalidByNpiCount: number;
  recordsInvalidByTinCount: number;
  recordsInvalidByNpiAndTinCount: number;
  recordsInvalidByNppesCount: number;
  invalidFormatNpis: string[];
  invalidFormatTins: string[];
  invalidNotFoundNpis: string[];
}

interface IncludedReports {
  projectDetailsTerminationOverview: boolean;
  serviceAreaSpecialtySummaryChangedGaps: boolean;
  serviceAreaSpecialtySummaryComparison: boolean;
  opportunitySpecialtySummaryChangedGaps: boolean;
  opportunitySpecialtySummaryComparison: boolean;
  terminationUploadFile: boolean;
  serviceAreaProviders: boolean;
  ghostTerminationList: boolean;
  opportunityProviders: boolean;
}

interface ITermRefinementOption {
  isAllLocations: boolean;
  isAllSpecialties: boolean;
  infoMessage: JSX.Element;
}

export {
  BulkCreateProviderTerminationsModel,
  BulkProviderTerminationMethod,
  BulkTerminationProjectResponseModel,
  ImportBulkTerminationFileResponse,
  IncludedReports,
  ITermRefinementOption,
  TerminationsWizardContextSteps,
  TerminationsWizardStepProps,
};
